import i18n from '@/plugins/i18n';
import utils from '@/utils/functions';

const staticData = () => {
  return {
    columns: [
      {
        key: 'affiliate_name',
        label: i18n.t('Name'),
        custom_class: 'text-left'
      },
      {
        key: 'sub_brand_name',
        label: i18n.t('Sub Brand'),
        custom_class: 'text-left'
      },
      {
        key: 'affiliate_token',
        label: i18n.t('Token'),
        custom_class: 'text-left'
      },
      {
        key: 'entry_value',
        label: i18n.t('Valor'),
        formatter: utils.formatMoneyFloat,
        custom_class: 'text-center'
      },
      {
        key: 'entry_status',
        label: i18n.t('Status'),
        formatter: (v) => i18n.t(v),
        custom_class: 'text-center'
      },
      {
        key: 'entry_type',
        label: i18n.t('Type'),
        formatter: (v) => i18n.t(v),
        custom_class: 'text-center'
      },
      {
        key: 'entry_created_at',
        label: i18n.t('Data de criação'),
        formatter: utils.formatDateTime,
        custom_class: 'text-center'
      },
      {
        key: 'affiliate_payment_type',
        label: i18n.t('Payment Type'),
        custom_class: 'text-center'
      },
      {
        key: 'payment_key',
        label: i18n.t('Payment key'),
        custom_class: 'text-left'
      },
      {
        key: 'payment_key_type',
        label: i18n.t('Payment key type'),
        custom_class: 'text-left',
        short_name: i18n.t('Key Type (Pay)')
      },
      {
        key: 'payment_type',
        label: i18n.t('Payment type'),
        custom_class: 'text-left',
        short_name: i18n.t('Type (Pay)')
      },
      {
        key: 'updated_at',
        label: i18n.t('Data de atualização'),
        formatter: utils.formatDateTime,
        custom_class: 'text-center'
      }
    ]
  };
};

export default staticData;
